import React, { useEffect, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { listUsers } from '../graphql/queries';
import { updateUser } from '../graphql/mutations';
import { makeStyles, Table, TableHead, TableRow, TableCell, TableBody, Button, Select, MenuItem } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '15px',
    backgroundColor: '#f9f9f9'
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem'
  },
  actionButton: {
    color: '#01b5e2',
    borderColor: '#01b5e2',
    '&:hover': {
      backgroundColor: '#01b5e2',
      color: 'white',
    }
  }
}));

const ManageUsers = () => {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const [editableUser, setEditableUser] = useState({});

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await API.graphql(graphqlOperation(listUsers));
      setUsers(response.data.listUsers.items);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (userId) => {
    setEditableUser({ ...editableUser, [userId]: true });
  };

  const handleCancel = (userId) => {
    setEditableUser({ ...editableUser, [userId]: false });
  };

  const handleInputChange = (event, userId, field) => {
    const newUsers = users.map(user => user.id === userId ? { ...user, [field]: event.target.value } : user);
    setUsers(newUsers);
  };

  const handleSave = async (userId) => {
    try {
      const userToSave = users.find(user => user.id === userId);
      await API.graphql(graphqlOperation(updateUser, { input: { id: userId, userType: userToSave.userType } }));
      setEditableUser({ ...editableUser, [userId]: false });
    } catch (error) {
      console.log("Error updating user: ", error);
    }
  };

  return (
    <div className={classes.tableContainer}>
      <Table>
        <TableHead>
          <TableRow className={classes.tableHeader}>
            <TableCell className={classes.tableCell}>User</TableCell>
            <TableCell className={classes.tableCell}>User Type</TableCell>
            <TableCell className={classes.tableCell}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id} className={classes.tableRow}>
              <TableCell className={classes.tableCell}>
                {user.name}
              </TableCell>
              <TableCell className={classes.tableCell}>
                {editableUser[user.id] ? (
                  <Select
                    value={user.userType}
                    onChange={(event) => handleInputChange(event, user.id, 'userType')}
                  >
                    <MenuItem value="ACECURA_ADMIN">ACECURA_ADMIN</MenuItem>
                    <MenuItem value="APP_USER">APP_USER</MenuItem>
                  </Select>
                ) : (
                  user.userType
                )}
              </TableCell>
              <TableCell className={classes.tableCell}>
                {editableUser[user.id] ? (
                  <>
                    <Button variant="outlined" className={classes.actionButton} onClick={() => handleSave(user.id)}>Save</Button>
                    <Button variant="outlined" className={classes.actionButton} onClick={() => handleCancel(user.id)}>Cancel</Button>
                  </>
                ) : (
                  <Button variant="outlined" className={classes.actionButton} onClick={() => handleEdit(user.id)}>Edit</Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ManageUsers;
